export default __webpack_public_path__ + "static/media/c1.698f86d0.svg";